module.exports = __webpack_public_path__ + "img/64exp.3445aafb.jpg";